import { useEffect, useState } from 'react';

// SSR-safe media query hook.
//
// Initial state leest `window.matchMedia(query).matches` SYNCHROON in de
// useState-initializer — dit is wat renderToStaticMarkup oppikt. Het
// useEffect-blok subscribet op runtime resize-events en sync't state als de
// query veranderde sinds de initial render.
//
// Bij `typeof window === 'undefined'` (Node-SSR) of zonder matchMedia (oude
// browser / happy-dom-edge-case) returnen we `false`. Componenten die de
// hook gebruiken behoren dan een correct desktop/default-pad te renderen.
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    mql.addEventListener('change', handler);
    // Re-sync na mount voor het geval de query is veranderd of de browser
    // pas na de useState-init een nieuwe matches-waarde heeft.
    setMatches(mql.matches);
    return () => mql.removeEventListener('change', handler);
  }, [query]);

  return matches;
}
